import * as React from 'react';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { DateRange } from 'react-date-range';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Select, MenuItem, InputLabel, Slider, TextField, Stack, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import moment from 'moment'
import { getCitiesListing } from '../Controllers/ScopeManagement';
import mainContext from '../contexts/mainContext';
export default function Filter({ typeList }) {

    const { filterState, setFilterState } = React.useContext(mainContext);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [cities, setCities] = React.useState([]);
    React.useEffect(() => {
        async function getCity() {
            const res = await getCitiesListing();
            if (res.data.status === 200) {
                setCities(res.data.data)
            }
        }
        getCity()
    }, [])

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClear = () => {
        setFilterState({})
        setAnchorEl(null)
    }

    const handleStatusChange = (event) => {
        setFilterState({ ...filterState, fRole: event.target.value });
    };
    return (
        <>
            <Tooltip title="Filter">
                <FilterAltIcon
                    className='pointer' style={{
                        margin: "0 1rem 0 1rem"
                    }}
                    onClick={handleClick}
                />
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <Container>
                    <FormControl>
                        <strong>Review For</strong>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            defaultValue={filterState?.fRole ? filterState?.fRole : ""}
                            onChange={handleStatusChange}
                        >
                             <FormControlLabel value="Seeker" control={<Radio />} label="Customer" />
                            <FormControlLabel value="BabySitter" control={<Radio />} label="BabySitter" />
                            <FormControlLabel value="HouseKeeper" control={<Radio />} label="HouseKeeper" />
                        </RadioGroup>
                    </FormControl>

                    {/* rating filter */}
                    {typeList && typeList.includes("rating") &&
                        <>
                            <FormControl sx={{ width: '100%' }}>
                                <div className="rating">
                                    <strong>By Rating</strong>
                                    <Slider
                                        step={1}
                                        getAriaLabel={() => 'Ratings'}
                                        value={filterState && typeof (filterState.fRating) === "object" ? filterState.fRating : [0, 5]}
                                        onChange={(event, value) => { setFilterState({ ...filterState, fRating: value }) }}
                                        valueLabelDisplay="auto"
                                        max={5}
                                    />
                                </div>
                            </FormControl>
                            <Divider /><br />
                        </>
                    }

                    {/*FROM AND TO DATE PICKER*/}
                    {typeList && typeList.includes("date-range") &&
                        <>
                            <div className='date_div'>
                                <strong >By Date</strong>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        id='Date From'
                                        type={"date"}
                                        fullWidth
                                        defaultValue={filterState.fStartDate ? moment(filterState.fStartDate).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD")}
                                        label="Start date"
                                        onChange={(e) => {
                                            setFilterState({
                                                ...filterState,
                                                fStartDate: moment(e.target.value).format('YYYY-MM-DD')
                                            });
                                        }}

                                    />

                                    <TextField
                                        id='Date To'
                                        type={"date"}
                                        fullWidth
                                        label="End date"
                                        defaultValue={filterState.fEndDate ? moment(filterState.fEndDate).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD")}
                                        onChange={(e) => {
                                            setFilterState({
                                                ...filterState,
                                                fEndDate: moment(e.target.value).format('YYYY-MM-DD')
                                            });
                                        }}

                                    />
                                </Stack>

                            </div>
                            <Divider /><br />
                        </>
                    }

                    {/* city filter */}
                    {typeList && typeList.includes("city") &&
                        <>
                            <div className='country_select_div'>
                                <FormControl sx={{ width: '100%', color: 'green' }}>
                                    <InputLabel id="city">City</InputLabel>
                                    <Select
                                        multiple
                                        className='city'
                                        id='city'
                                        label="City"
                                        defaultValue={filterState ? typeof (filterState.fCity) == 'object' ? filterState.fCity.length != 0 ? filterState.fCity : [] : [] : []}
                                        onChange={(e) => { setFilterState({ ...filterState, fCity: e.target.value }) }}
                                    >
                                        {cities.map((data) => <MenuItem value={data.city}>{data.city}</MenuItem>)}
                                    </Select>
                                </FormControl>
                                <Divider /><br />
                            </div>
                        </>
                    }

                    <Actions>
                        {/* <Button variant="contained" size='small' style={{ textTransform: "unset" }} onClick={handleApply}>Apply filter</Button> */}
                        <Button variant="outlined" size='small' style={{ textTransform: "unset" }} onClick={handleClear}>Clear filter</Button>
                    </Actions>

                </Container>
            </Menu>
        </>
    );
}

const Container = styled("div")`
    padding: 1rem;
    .my-2{
        margin-top: 1rem;
    }
    .rating{
        display: flex;
        flex-direction: column;
        margin-bottom: 0.5rem;
        row-gap  :0.5rem;
    }
    &>.country_select_div{
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
    &>.date_div{
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
    max-width:350px;
`;

const Actions = styled("div")`
    margin-top: 1rem;
    display: flex;
    column-gap: 1rem;
`;
